import React, { FC } from 'react';
import { Button, TrevorIcon, Banner } from '@trevor/ui-components';
import styled from 'styled-components';
import AjaxSpinner from '@/components/AjaxSpinner';
import { ADD_NEW_DATASOURCE_BUTTON } from '@/constants/test-ids';

const ButtonActionContainer = styled.div`
  position: relative;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: var(--spacing-l);
  width: auto;

  :has(button:only-child) {
    display: flex;
    justify-content: center;
  }

  > button {
    visibility: ${(p) => (p.isLoading ? 'hidden' : 'visible')};
    width: 100%;
  }
`;

const Loading = styled(AjaxSpinner)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

type ConnectionOptionSectionProps = {
  isLoading: boolean;
  isSelfHosted: boolean;
  isSuperAdmin: boolean;
  showConnectDatabaseButton: boolean;
  onConnectDatabase: F0;
};
export const ConnectionOptionSection: FC<ConnectionOptionSectionProps> = ({
  isLoading,
  isSelfHosted,
  isSuperAdmin,
  showConnectDatabaseButton,
  onConnectDatabase,
}) => {
  const isSelfHostedNotAdmin = isSelfHosted && !isSuperAdmin;
  showConnectDatabaseButton =
    showConnectDatabaseButton && !isSelfHostedNotAdmin;

  return (
    <>
      {isSelfHostedNotAdmin && (
        <Banner severity="info">
          You don’t have any datasources. Please ask your team to invite you in
          to one.
        </Banner>
      )}
      <ButtonActionContainer isLoading={isLoading}>
        {isLoading && <Loading />}
        {showConnectDatabaseButton && (
          <Button
            disabled={isSelfHosted && !isSuperAdmin}
            onClick={onConnectDatabase}
            size="large"
            icon={<TrevorIcon name="plus" />}
            data-testid={ADD_NEW_DATASOURCE_BUTTON}
          >
            Connect a database
          </Button>
        )}
      </ButtonActionContainer>
    </>
  );
};
